import { withDefaultPaymentProps } from 'viewModel/richProfile/myAccount/payments/defaultPayment/withDefaultPaymentProps';
import DefaultPayment from 'components/RichProfile/MyAccount/Payments/DefaultPayment/DefaultPayment';

export default withDefaultPaymentProps(DefaultPayment);
